import { useEffect, useState } from 'react'

import { http } from '@itau-loans-www/services'

const useResult = ({ isToGetNumber = false }) => {
  const [phone, setPhone] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getData = async () => {
      await http.proposal
        .getLeadPhone()
        .then((response) => {
          setPhone(response.lead_phone_number)
          setIsLoading(false)
        })
        .catch(() => setIsLoading(false))
    }
    if (isToGetNumber) getData()
  }, [isToGetNumber])

  return {
    phone,
    isLoading
  }
}

export { useResult }
